import {
    Component, OnDestroy, Input, Output, EventEmitter, OnInit,
    ViewEncapsulation, ElementRef, ViewChild, AfterViewInit, OnChanges, SimpleChanges, ViewChildren, QueryList
} from '@angular/core';

import { FormGroup, FormBuilder, FormControl } from '@angular/forms';

import { get, isBoolean, isNumber } from 'lodash';

import { VehicleListFilterRequest } from '../../../commons/models/remote.request/VehicleListFilterRequest';
import { VehicleService } from '@commons/services/vehicle/vehicle.service';
import { Tag } from '../../../commons/models/domain/Tag';
import { OptionItem } from '@commons/models/other/option-item.model';
import { Consts } from '../../../commons/consts/consts';
import { Config } from '../../../commons/models/domain/Config';
import { CacheService } from '@commons/services/cache/cache.service';
import {debounceTime, of, Subject, Subscription, switchMap} from 'rxjs';
import {TranslateHelperService} from "@shared/services/translate-helper.service";
import { IFilterVehicle, IFilterVehicleOption, IOnChangedTachoFilters, ISubmitFilters } from '@src/app/interfaces/filters-vehicle.interface';
import { FilterLockType, FilterVehicleType } from '@src/app/enum/filters-vehicle.enum';
import { TagsListFilterRequest } from '@commons/models/remote.request/TagsListFilterRequest';
import { WebAccessService } from '@commons/services/web.access/web-access.service';
import { FilterControlComponent } from './filter-control/filter-control.component';
import { TranslateService } from '@ngx-translate/core';
import { PermissionService } from '@shared/services/permission.service';

@Component({
    selector: 'tk-vehicle-list-filter',
    templateUrl: './vehicle-list-filter.component.html',
    styleUrls: ['./vehicle-list-filter.component.less'],
    encapsulation: ViewEncapsulation.None
})
export class VehicleListFilterComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges {

    private readonly columnKey = 'vehicles-list-displayed-column';

    @ViewChildren(FilterControlComponent) public filterControlsQuery: QueryList<FilterControlComponent>;
    /**
     * Mode - 'lite' or 'full'
     */
    @Input() public mode = 'lite';
    @Input() public isEtoll: boolean;
    @Input() public isTacho: boolean;

    @Input() public filters: IFilterVehicle[] = [];
    @Input() public tachoFilters: IOnChangedTachoFilters;

    @Input() public additionalParams: any;

    @ViewChild('filterBlock') filterBlock?: ElementRef;

    @Output() onHandleOnHeightChanged: EventEmitter<any> = new EventEmitter<any>();
    @Output() onFilterChanged: EventEmitter<any> = new EventEmitter<any>();
    @Output() onFilterTachoChanged: EventEmitter<IOnChangedTachoFilters> = new EventEmitter();

    baseHeight?: number;

    public inputHasFocus = false;


    /**
     * Form
     */
    public form: FormGroup;

    /**
     *
     */
    public displayFieldControl: FormControl;

    @Output()
    public onDisplayFieldChanged: EventEmitter<any> = new EventEmitter();

    /**
     * Flag indicating whether filter request is being processed
     */
    public loading = false;

    /**
     * Filter request subject
     */
    public filterRequestSubject: Subject<null> = new Subject<null>();

    /**
     * Subscription to stream of form controls value changess
     */
    private readonly filterRequestSub: Subscription;

    /**
     * Subscription to stream of filtered vehicles
     */
    private readonly filteredVehiclesSub: Subscription;

    /**
     *
     */
    public vehicleStatuses: OptionItem[] = [];
    public vehicleTachoStatuses: OptionItem[] = [];
    public vehicleIndicatorTypes: OptionItem[] = [];
    public fieldTypes:OptionItem[] = [];

    public isVisibleLockFilter: boolean;

    /**
     *
     */
    public config?: Config;

    public filtersStatusTachoConfig: IFilterVehicle;
    public filtersStatusConfig: IFilterVehicle;
    public filtersGroupConfig: IFilterVehicle;
    public filtersLockConfig: IFilterVehicle;
    public filtersStatusCurrentFilters: ISubmitFilters;
    public filtersGroupCurrentFilters: ISubmitFilters;
    public filtersLockCurrentFilters: ISubmitFilters;

    /**
     * needed to find out if there is any result
     */
    public currentTotal = 0;

    private filteredStatuses = [
        { filterType: 0, statuses: [] }, // Wszystkie
        { filterType: 1, statuses: [3, 4, 5] },
        { filterType: 2, statuses: [1] },
        { filterType: 4, statuses: [2] },
        { filterType: 6, statuses: [6] }
    ];

    /**
     * Component constructor
     * @param $vehicles vehicles service
     */
    constructor(
        private $fb: FormBuilder,
        private $vehicle: VehicleService,
        private $cache: CacheService,
        private translateHelperService: TranslateHelperService,
        private $webAccess: WebAccessService,
        private translate: TranslateService,
        private permissionService: PermissionService,
    ) {

        // Prepare form and control
        this.form = this.$fb.group({
            Field: ['Description'],
            Status: [0],
            Phrase: [null],
            Tags: [[]],
            IgnitionBlockerState: [null],
        });


        // dane na liscie
        this.displayFieldControl = this.$fb.control(undefined);

        this.displayFieldControl.valueChanges.subscribe(c => {
            this.saveDisplayedColumn(c);
            this.onDisplayFieldChanged.emit(c);
        });

        this.form.valueChanges.pipe(debounceTime(500)).subscribe(changes => {
            const data = this.form.getRawValue();
            // Save in cache
            this.$cache.setCache('vehicle.filter', data);
            this.filterRequestSubject.next(data);
        });

        // Subscribe for filtered vehicles to count vehicles per status
        this.filteredVehiclesSub = this.$vehicle.getListFilteredCount$().subscribe(data => {
            this.loading = false;

            const nums = { 0: 0, 1: 0, 2: 0, 4: 0, 6: 0 };

            // jak jest counter to uzywamy
            if (data.counter) {
                for (const c of data.counter) {
                    const filteredStatus = this.filteredStatuses.find(function (f) { return f.statuses.includes(c.Type); });
                    if (filteredStatus) {
                        (nums as any)[filteredStatus.filterType] = c.Count;
                    }
                    nums[0] += c.Count;
                }
            } else {
                const _vehicles = data.vehicles || [];
                for (const vehicle of _vehicles) {
                    const filteredStatus = this.filteredStatuses.find(function (f) { return f.statuses.includes(vehicle.St); });
                    if (filteredStatus) {
                        (nums as any)[filteredStatus.filterType] += 1;
                    }
                    nums[0] += 1;
                }
            }

            const keys = Object.keys(nums);
            for (let i = keys.length - 1; i >= 0; i--) {
                const status = parseInt(keys[i], 10);
                const item = this.vehicleStatuses.find(_item => _item.value === status);
                if (item) {
                    item.data = { count: (nums as any)[status] };
                }
            }
            this.currentTotal = nums[0];
        });

        // Subscribe for filter request changes to send a request
        // kolejnosc jest wazna ze wzgledu na to startWith
        this.filterRequestSub = this.filterRequestSubject.subscribe(_filter => {
            // kopia musi byc
            let filter = JSON.parse(JSON.stringify(_filter));

            // przetworzenie filtra
            if (filter && filter != null) {
                const isStatusNull = !filter.Status || filter.Status === 0;
                const isTagsNull = !filter.Tags || filter.Tags.length === 0;
                const isPhraseNull = !filter.Phrase;
                const additional = this.additionalParams != undefined && this.additionalParams != null;
                const isLockNull = filter?.IgnitionBlockerState === null;

                if (isStatusNull && isTagsNull && isPhraseNull && !additional && isLockNull) {
                    filter = null;
                } else {
                    // przygotowanie statusow
                    const filteredStatus = this.filteredStatuses.find(function (f) { return f.filterType === filter.Status; });
                    if (filteredStatus) {
                        filter.Statuses = filteredStatus.statuses;
                    } else {
                        filter.Statuses = [];
                    }


                    // parametry dodatowe z filtra na liscie full
                    if (additional) {
                        if (this.additionalParams.BinaryParamName) {
                            filter.BinaryParamName = this.additionalParams.BinaryParamName;
                        }
                        if (this.additionalParams.BinaryParamState && this.additionalParams.BinaryParamState !== 'all') {
                            filter.BinaryParamState = this.additionalParams.BinaryParamState === 'on' ? 1 : 0;
                        }
                    }

                    // przekazanie do list takze current total
                    filter.CurrentTotal = this.currentTotal;
                }
            }

            const filterData = {
                ...filter,
                Tags: filter?.Tags || [],
                IgnitionBlockerState: isNumber(filter?.IgnitionBlockerState) ? filter.IgnitionBlockerState === FilterLockType.Lock ? true : false : undefined,
            };
            this.onFilterChanged.emit(filterData);
            this.loading = true;
            this.$vehicle.findVehicle(filterData as VehicleListFilterRequest);
        });
    }

    ngOnInit() {
        this.setDisplayedColumn();
        this.setTranslations();
        this.checkPermissionLock();

        // Get from cache
        const savedFilter = this.$cache.getCache('vehicle.filter');
        if (savedFilter) {
            this.form.patchValue(savedFilter);
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes && changes['additionalParams']
            && changes['additionalParams'].currentValue
            && !changes['additionalParams'].firstChange
        ) {
            const data = this.form.getRawValue();
            this.filterRequestSubject.next(data);
        }
    }

    private checkPermissionLock(): void {
        this.isVisibleLockFilter = this.permissionService.hasBlockerRead() || this.permissionService.hasBlockerReadWrite();
    }

    public clearAllFilters(): void {
        this.filterControlsQuery.map(control => control.clearFiltersValue());
        this.form.patchValue({
            Status: null,
            Tags: [],
            Phrase: null,
            IgnitionBlockerState: null,
        });
    }

    public onSubmitFilters(data: ISubmitFilters, filterData: IFilterVehicle): void {
        if (filterData.type === FilterVehicleType.Status) {
            this.form.get('Status')?.setValue(data?.selectedControlValue);
            this.filtersStatusCurrentFilters = {...data};
            return;
        }
        if (filterData.type === FilterVehicleType.Group) {
            this.filtersGroupCurrentFilters = {...data};
            if (data.selectedControlValue) {
                const tagData = this.filtersGroupConfig.options.find(item => item.value === data.selectedControlValue);
                this.handleOnSelectedTags([tagData?.data]);
                return;
            }
            this.handleOnSelectedTags([]);
            return;
        }
        if (filterData.type === FilterVehicleType.Blocking) {
            this.form.get('IgnitionBlockerState')?.setValue(data?.selectedControlValue);
            this.filtersLockCurrentFilters = {...data};
            return;
        }
        if (filterData.type === FilterVehicleType.TachoStatus) {
            this.onFilterTachoChanged.emit({
                selectedStatus: data.selectedControlValue,
            });
            return;
        }
    }

    private setTranslations(): void {
        this.vehicleStatuses = this.translateHelperService.translateOptionItems(Consts.vehicleStatuses);
        this.vehicleTachoStatuses = this.translateHelperService.translateOptionItems(Consts.vehicleTachoStatuses);
        this.vehicleIndicatorTypes = this.translateHelperService.translateOptionItems(Consts.vehicleIndicatorTypes);
        this.fieldTypes = this.translateHelperService.translateOptionItems(Consts.fieldTypes);
        this.setFiltersConfig();
    }

    private setFiltersConfig(): void {
        const filtersStatusOptions: IFilterVehicleOption[] = this.vehicleStatuses.map(({ checkboxColor, label, value, data }) => ({ checkboxColor, label, value, data })) as IFilterVehicleOption[];
        this.filtersStatusConfig = {
            filterLabel: this.translate.instant('labels.status'),
            type: FilterVehicleType.Status,
            dropdownLabel: this.translate.instant('filterByStatuses'),
            options: filtersStatusOptions
        };
        this.filtersGroupConfig = {
            filterLabel: this.translate.instant('vehicle-indicator.group'),
            type: FilterVehicleType.Group,
            dropdownLabel: this.translate.instant('showOnlyGroup'),
            options: [],
        };
        this.filtersLockConfig = {
            filterLabel: this.translate.instant('blocked'),
            type: FilterVehicleType.Blocking,
            dropdownLabel: this.translate.instant('displayOnly'),
            options: [
                { label: this.translate.instant('unBlockVehicles'), value: FilterLockType.Unblock },
                { label: this.translate.instant('blockedVehicles'), value: FilterLockType.Lock }
            ],
        };
        const filtersStatusTachoOptions: IFilterVehicleOption[] = this.vehicleTachoStatuses.map(({ checkboxColor, label, value, data }) => ({ checkboxColor, label, value, data })) as IFilterVehicleOption[];
        this.filtersStatusTachoConfig = {
            filterLabel: this.translate.instant('labels.status'),
            type: FilterVehicleType.TachoStatus,
            dropdownLabel: this.translate.instant('filterByStatuses'),
            options: filtersStatusTachoOptions,
        };
        this.getGroups();
    }

    private getGroups(): void {
        if (!this.filtersGroupConfig?.options.length) {
            of(<TagsListFilterRequest>{Phrase: '', TagType: 0})
                .pipe(
                    switchMap(request => this.$webAccess.GetTagsListByFilter(request))
                )
                .subscribe(response => {
                    this.filtersGroupConfig = {
                        ...this.filtersGroupConfig,
                        options: response.Result.map(item => ({ label: item.L, value: item.Id, data: item })) as IFilterVehicleOption[],
                    };
                }); 
        }
    }

    private setDisplayedColumn() {
        const eTollColumn = 19;
        if (this.isEtoll) {
            this.displayFieldControl.setValue(eTollColumn);
            return;
        }
        const itemLS = localStorage.getItem(this.columnKey);
        const curField = itemLS ? +itemLS : eTollColumn;
        this.displayFieldControl.setValue(curField);
    }

    private saveDisplayedColumn(newValue: string) {
        if (!this.isEtoll) {
            localStorage.setItem(this.columnKey, newValue);
        }
    }

    /**
     * On destroy lifecycle hook
     */
    public ngOnDestroy(): void {
        if (this.filterRequestSub) {
            this.filterRequestSub.unsubscribe();
        }
        if (this.filteredVehiclesSub) {
            this.filteredVehiclesSub.unsubscribe();
        }
    }


    /**
     * Handles close event with selected tags
     * @param selectedTags
     */
    public handleOnSelectedTags(selectedTags: Tag[]): void {
        this.form.controls['Tags'].setValue(selectedTags);
    }


    /**
     * Handles enter event from search input
     */
    public onSearchEnter(): void {
        const filter = this.form.getRawValue();
        this.filterRequestSubject.next(filter);
    }

    /**
    * Handles enter event from search input
    */
    public onClearEnter(): void {
        const filter = this.form.getRawValue();
        this.filterRequestSubject.next(filter);
    }

    ngAfterViewInit() {
        this.baseHeight = this.filterBlock?.nativeElement.offsetHeight;
    }

    /**
 * Handle container change of tags selector
 */
    public handleOnHeightChanged(h: number) {
        setTimeout(() => {
            const height = this.filterBlock?.nativeElement.offsetHeight;
            let delta = height - this.baseHeight!;
            if (delta < 0) {
                delta = 0;
            }
            this.onHandleOnHeightChanged.emit(this.baseHeight! + delta);
        }, 100);
    }

    onInputFocus(flag: boolean) {
        this.inputHasFocus = flag;
    }

    onSearchClear() {
        throw new Error('method onSearchClear not implemented')
    }

    public setFilters(data: VehicleListFilterRequest): void {
        const setLockValue = (blockerState?: boolean): FilterLockType | null => {
            if (isBoolean(blockerState)) {
                return blockerState ? FilterLockType.Lock : FilterLockType.Unblock;
            }
            return null;
        };
        this.form.patchValue(
            {
                Phrase: data?.Phrase,
                Field: data?.Field || 'Description',
                Status: data?.Status,
                Tags: data?.Tags,
                IgnitionBlockerState: setLockValue(data?.IgnitionBlockerState),
            },
            { emitEvent: false },
        );
        this.filtersStatusCurrentFilters = {
            selectedControlValue: data.Status,
        };
        this.filtersGroupCurrentFilters = {
            selectedControlValue: get(data, 'Tags[0].Id', null),
        };
        this.filtersLockCurrentFilters = {
            selectedControlValue: setLockValue(data?.IgnitionBlockerState),
        };
    }

}
